<script>
import demoCdList from '@/components/demoCdList';

export default {
  name: 'album15',
  components: {
    demoCdList
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">
    
    <div class="contents-container">
      <div class="title">{{$t('message.demo.pageName')}}</div>
      <demo-cd-list :is-center="true"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
